module.exports = __webpack_public_path__ + "img/公众号.5bd3e229.jpg";